import React from "react";
import { hydrate } from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter as Router } from "connected-react-router";
import { Frontload } from "react-frontload";
import { loadableReady } from "@loadable/component";
import { configureStore } from "shared/store";
import App from "shared/App";
import { browserResponsiveMode } from "shared/components/ResponsiveLoader";
import createHistory from "shared/store/history";
import polyfillPromise from "shared/helpers/client-polyfill";
import DTM from "shared/helpers/DTM";
const history = createHistory();

// Create/use the store
// history MUST be passed here if you want syncing between server on initial route
const store =
    window.store ||
    configureStore({
        initialState: window.__PRELOADED_STATE__,
        history,
    });

polyfillPromise.then(() => {
    loadableReady(() => {
        const deviceWidth = window.__APP_DATA__.ssrDeviceWidth || browserResponsiveMode();

        hydrate(
            <Provider store={store}>
                <Router history={history}>
                    <Frontload noServerRender={true}>
                        <App deviceWidth={deviceWidth} />
                    </Frontload>
                </Router>
            </Provider>,
            document.getElementById("app")
        );
    });
});

if (process.env.NODE_ENV === "development") {
    if (module.hot) {
        module.hot.accept();
    }

    if (!window.store) {
        window.store = store;
    }
}

DTM.init();
